module.exports = __webpack_public_path__ + "static/media/Shubhangi Khanna.df4c32a7.jpg";